module.exports = __webpack_public_path__ + "media/images/pc/articles/concept-dfd1c950c495b30e8d00e880c57feaa5.webp";